/**
 * Asset: Multi-store config
 * ------------------------------------------------------------------------------
 * Configuration file used in `redirect.js`.
 * - All properties are required, leave empty string if unused.
 */
window.Frame = window.Frame || {};
window.Frame.MultiStore = [
  {
    storeCode: 'GB',
    storeName: 'United Kingdom',
    storeUrl: 'https://www.toa.st/',
    supportedCurrencies: 'GBP',
    supportedStores: 'GG, JE, IM',
  },
  {
    storeCode: 'AU',
    storeName: 'Australia',
    storeUrl: 'https://au.toa.st/',
    supportedCurrencies: 'AUD',
    supportedStores: 'CK,CX,CC,FJ,FM,KI,MH,NA,NC,NF,NU,NZ,PW,SB,TL,TO,TV,VU,WS',
  },
  {
    storeCode: 'CA',
    storeName: 'Canada',
    storeUrl: 'https://ca.toa.st',
    supportedCurrencies: 'CAD',
    supportedStores: 'CA',
  },
  {
    storeCode: 'US',
    storeName: 'United States',
    storeUrl: 'https://us.toa.st',
    supportedCurrencies: 'USD',
    supportedStores: 'US',
  },
  {
    storeCode: 'EU',
    storeName: 'Europe',
    storeUrl: 'https://eu.toa.st',
    supportedCurrencies: 'EUR',
    supportedStores: 'AD,AL,AM,AT,AX,BA,BE,BG,BY,CY,CH,CZ,DE,DK,EE,ES,FI,FO,FR,GE,GI,GR,GL,HR,HU,IE,IS,IT,LT,LU,LV,LI,MC,MD,ME,MK,MT,NL,NO,PL,PT,RO,RS,SE,SI,SJ,SK,SM,TR,UA,VA,XK',
  },
  {
    storeCode: 'ROW',
    storeName: 'Rest of World',
    storeUrl: 'https://au.toa.st',
    supportedCurrencies: 'AUD',
    supportedStores: 'AE,AF,AG,AI,AM,AN,AO,AQ,AR,AS,AW,AZ,BB,BD,BF,BH,BI,BJ,BM,BN,BO,BQ,BR,BS,BT,BW,BZ,CF,CG,CI,CL,CM,CN,CO,CR,CU,CV,DJ,DM,DO,DZ,EC,EG,EH,ER,ET,FK,GA,GD,GD,GE,GF,GH,GM,GN,GP,GQ,GT,GU,GW,GY,HK,HN,HT,ID,IL,IN,IO,IQ,IR,JM,JO,JP,KE,KG,KH,KM,KR,KW,KY,KZ,LA,LB,LK,LR,LS,LY,MA,MG,ML,MM,MN,MO,MQ,MR,MS,MU,MV,MW,MX,MY,MZ,NA,NE,NG,NI,NP,OM,PA,PE,PG,PH,PK,PR,PY,QA,RW,SA,SC,SD,SG,SL,SN,SO,SR,ST,SV,SX,SY,SZ,TD,TG,TH,TJ,TM,TN,TT,TW,TZ,UG,UY,UZ,VE,VG,VI,VN,YE,ZA,ZM,ZW',
  },
];
